export default __webpack_public_path__ + "static/media/bunny.3e3d0bcf.obj";